import React, {
  createContext,
  type Dispatch,
  type FC,
  type PropsWithChildren,
  type SetStateAction,
  useState,
} from 'react'

type InformationPanelContextProps = {
  panel: Utils.Optional<Queries.ContentfulInformationButtonFragment>
  setPanel: Dispatch<
    SetStateAction<Utils.Optional<Queries.ContentfulInformationButtonFragment>>
  >
}

export const InformationPanelContext =
  createContext<InformationPanelContextProps>(undefined)

export const InformationPanelProvider: FC<PropsWithChildren> = ({
  children,
}) => {
  const [panel, setPanel] =
    useState<InformationPanelContextProps['panel']>(undefined)

  return (
    <InformationPanelContext.Provider
      value={{
        panel,
        setPanel,
      }}
    >
      {children}
    </InformationPanelContext.Provider>
  )
}
